import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import api from '@/axios';
import { GET_FOREST_TYPES_KEY } from '@/keys';
import type { ForestType } from '@/types/core/purchase-order/forest-type';

async function getForestTypes(): Promise<ForestType[]> {
  const response = await api.get<ForestType[]>('/forest-types');

  return response.data;
}

export function useGetForestTypes(): UseQueryResult<ForestType[], Error> {
  return useQuery({
    queryKey: GET_FOREST_TYPES_KEY,
    queryFn: getForestTypes,
  });
}
